import { HelpModuleType } from './helpTypes';



export const initialState: HelpModuleType = {
  
    success: null, 
    editSuccess:null,
    addSuccess:null,
    error : null,
    statusCode :null,
    message : "",
    addMessage:"",
    editMessage:"",
    fetching:false,
    helpModuleList :[],
    helpModuleTotalCount:0

   
}

